import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import {colors} from '../../../constants';
import IconSvg from '../IconSvg';


const FileName = props => {
  const {size, name, cancelHandler, type} = props;

  return (
    <div
      css={css`
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: ${size/4}px 0;
      `}
    >
      {type && name && <IconSvg type={type} size={size} />}
      <div
        css={css`
          margin: 0 ${size/4}px;
          font-size: ${size * 0.75}px;
          color: ${colors.greySecondary};
        `}
      >
        {name}
      </div>
      {name && (
        <IconSvg
          type="x-pink"
          size={size*0.75}
          onClick={cancelHandler}
        />
      )}
    </div>
  )
};

FileName.propTypes = {
  cancelHandler: PropTypes.func,
  type: PropTypes.string,
  name: PropTypes.string,
  size: PropTypes.number
};

export default FileName;
